import VisitorService from "../services/VisitorService";
import StoreContainer from "../stores/StoreContainer";
import { VisitorLogRequest, VisitorEvent, LogLevel } from "../types";

export function logError(message: string) {
  const newEvent = storeNewEvent(message, LogLevel.error);
  postEvent(newEvent);
}

export function logInfo(message: string) {
  storeNewEvent(message, LogLevel.info);
}

function storeNewEvent(message: string, level: LogLevel): VisitorEvent {
  //create the event
  const newEvent: VisitorEvent = {
    Message: message,
    Date: new Date(),
    Level: level,
    EngagementId: StoreContainer.EngagementStore.getEngagementId(),
    PreEngagementId: StoreContainer.EngagementStore.getPreEngagementId(),
    VisitorId: StoreContainer.VisitorStore.getVisitorId(),
    ActiveGroupId: StoreContainer.GroupStore.getActiveOrPageGroupId()
  };

  let events = StoreContainer.LocalStorageStore.get("events");

  if (!events) {
    events = [];
  }

  const eventMaxCount = 20;
  //We can increase value after ensuring that this is ok
  if (events.length > eventMaxCount) {
    events.shift();
  }

  events.push(newEvent);

  StoreContainer.LocalStorageStore.set("events", events);

  return newEvent;
}

function postEvent(event: VisitorEvent) {
  let data: VisitorLogRequest = {
    Event: event,
    Events: StoreContainer.LocalStorageStore.get("events"),
    DomainScope: StoreContainer.SettingStore.getCookieDomain(),
    InlineEnabled: !StoreContainer.SettingStore.isInlineDisabled(),
    IsPopout: StoreContainer.FrameStore.isPopOut(),
    PageGroupId: StoreContainer.GroupStore.getPageGroupId(),
    UI: "new"
  };

  VisitorService.postVisitorLog(StoreContainer.SettingStore.getSiteId(), data);
}
